import work1 from "./assets/projects/work1.png";
import work2 from "./assets/projects/work2.png";
import work3 from "./assets/projects/work3.png";
import work4 from "./assets/projects/work4.png";
import work5 from "./assets/projects/work5.png";

export const project = [
  {
    id: 1,
    name: "Imaginate",
    image: work1,
    github: "https://github.com/bhanu1129/image-generator",
    live: "https://ai-img-generator.web.app/",
  },
  {
    id: 2,
    name: "Vegas Flooring Outlet",
    image: work2,
    github: "https://github.com/bhanu1129/vegas-flooring-outlet",
    live: "https://vegas-flooring-outlet.vercel.app/",
  },
  {
    id: 3,
    name: "Organize Me",
    image: work3,
    github: "https://github.com/bhanu1129/OrganizeMe",
    live: "https://organize-me-neon.vercel.app/",
  },
  {
    id: 4,
    name: "Meeting Scheduler",
    image: work4,
    github: "https://github.com/bhanu1129/meeting-scheduler",
    live: "https://github.com/bhanu1129/meeting-scheduler",
  },
  {
    id: 5,
    name: "Weather App",
    image: work5,
    github: "https://github.com/bhanu1129/OrganizeMe/blob/main/src/pages/Weather.js",
    live: "https://organize-me-neon.vercel.app/weather",
  },
];
